export enum ReccurenceTypeEnum {
  OnceAWeek = 1,
  TwiceAWeek = 2,
}